"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var owa_options_core_2 = require("owa-options-core");
var store_1 = require("../data/store/store");
function saveKeyboardShortcutsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = store_1.default();
                    owa_options_core_1.updateUserOptions({
                        KeyboardShortcutsMode: optionState.shortcuts,
                    });
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'KeyboardShortcutsMode',
                                propertyType: 'Integer32',
                                propertyValue: "" + optionState.shortcuts,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = saveKeyboardShortcutsOption;
//# sourceMappingURL=saveKeyboardShortcutsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/orchestration/saveKeyboardShortcutsOption.js
// module id = 4975
// module chunks = 2